// Pengaturan fitur Ruang Kenang (album foto tamu)
export const GUEST_QUOTA = 25; // jatah foto per HP tamu (hanya dari kamera)
export const ACTIVE_DAYS = 30; // masa aktif album sejak diaktifkan
export const MAX_BEST = 5; // jumlah foto terbaik

// ------------------------------------------------------------
// Jenis acara. Semua teks yang berubah menurut jenis acara ada di sini,
// jadi acara non-pernikahan tidak pernah memunculkan kata "pengantin".
// ------------------------------------------------------------
export const EVENT_TYPES = [
  {
    id: "wedding", label: "Pernikahan", owner: "pengantin",
    coverLabel: "Pernikahan", coverName: "Nama pengantin",
    nameLabel: "Nama pengantin", namePlaceholder: "Rodi & Putri", nameRequired: true,
    waName: "Pengantin", coverTitle: "Cover dan pengantin",
    examples: ["Hari Pernikahan Kita", "Selamanya Dimulai di Sini", "Perayaan Cinta", "Awal dari Selamanya"],
  },
  {
    id: "birthday", label: "Ulang Tahun", owner: "pemilik acara",
    coverLabel: "Ulang Tahun", coverName: "Nama yang berulang tahun",
    nameLabel: "Nama yang berulang tahun", namePlaceholder: "Rina", nameRequired: true,
    waName: "Yang berulang tahun", coverTitle: "Cover ulang tahun",
    examples: ["Pesta Ulang Tahun", "Selamat Bertambah Usia", "Satu Tahun Lebih Bahagia", "Perayaan Hari Lahir"],
  },
  {
    id: "graduation", label: "Wisuda", owner: "pemilik acara",
    coverLabel: "Wisuda", coverName: "Nama wisudawan",
    nameLabel: "Nama wisudawan", namePlaceholder: "Budi Santoso", nameRequired: true,
    waName: "Wisudawan", coverTitle: "Cover wisuda",
    examples: ["Hari Kelulusan", "Langkah Baru Dimulai", "Perayaan Wisuda", "Akhirnya Lulus"],
  },
  {
    id: "reunion", label: "Reuni & Keluarga", owner: "pemilik acara",
    coverLabel: "Berkumpul", coverName: "Nama keluarga atau angkatan",
    nameLabel: "Nama keluarga atau angkatan (opsional)", namePlaceholder: "Keluarga Rahman", nameRequired: false,
    waName: "Keluarga / angkatan", coverTitle: "Cover acara",
    examples: ["Reuni Keluarga Besar", "Kumpul Bersama", "Temu Kangen", "Halal Bihalal"],
  },
  {
    id: "other", label: "Acara lain", owner: "pemilik acara",
    coverLabel: "", coverName: "",
    nameLabel: "Nama penyelenggara (opsional)", namePlaceholder: "Keluarga Rahman", nameRequired: false,
    waName: "Penyelenggara", coverTitle: "Cover acara",
    examples: ["Malam Perayaan", "Hari Bahagia Kita", "Kumpul Bersama", "Syukuran"],
  },
];
export const typeOf = (id) => EVENT_TYPES.find((t) => t.id === id) || EVENT_TYPES[0];

// ------------------------------------------------------------
// Nuansa foto. Diterapkan di HP tamu sebelum foto dikirim.
// Nilai pengolahannya ada di lib/photoFilter.js (id harus sama).
// ------------------------------------------------------------
export const FILTERS = [
  { id: "asli", label: "Asli", desc: "Apa adanya, tanpa efek" },
  { id: "hangat", label: "Hangat", desc: "Nuansa keemasan yang lembut" },
  { id: "senja", label: "Senja", desc: "Rona jingga seperti sore hari" },
  { id: "klasik", label: "Klasik", desc: "Warna pudar ala kenangan lama" },
  { id: "mono", label: "Hitam Putih", desc: "Kontras tegas tanpa warna" },
  { id: "embun", label: "Embun", desc: "Sejuk, cerah, dan bersih" },
];
export const filterOf = (id) => FILTERS.find((f) => f.id === id) || FILTERS[0];
